import { jsx, jsxs } from "react/jsx-runtime";
const SvgWarningAmber = (props) => /* @__PURE__ */ jsxs("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsxs("g", { clipPath: "url(#clip0_2743_89875)", children: [
    /* @__PURE__ */ jsx("path", { d: "M12 5.99L19.53 19H4.47L12 5.99ZM12 2L1 21H23L12 2Z", fill: "#DD3322" }),
    /* @__PURE__ */ jsx("path", { d: "M13 16H11V18H13V16Z", fill: "#DD3322" }),
    /* @__PURE__ */ jsx("path", { d: "M13 10H11V15H13V10Z", fill: "#DD3322" })
  ] }),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_2743_89875", children: /* @__PURE__ */ jsx("rect", { width: 24, height: 24, fill: "white" }) }) })
] });
export default SvgWarningAmber;
